import { getPathFromUrl } from '~/utilities/getPathFromUrl';
import type { PayloadInterface } from '~/types/AppData/AppDataInterface';

export const getCurrentPathname = (payloadToSSR: PayloadInterface): string => {
  const url = payloadToSSR.canonicalURL ? payloadToSSR.canonicalURL : '';

  return getPathFromUrl(url);
};
